import { IComponentOptions } from "angular";
import { ProcessViewController } from "./controller";

export const vsComponentName = "processGroupViewComponent";

export const processViewComponentOptions: IComponentOptions = {
  controller: ProcessViewController,
  controllerAs: "processViewController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridSettings: "<",
    processGroup: "<",
    onNewProcessSelected: "&",
    defaultQuery: "<",
    additionalGridColumns: "<",
    nameSingular: "<?",
    namePlural: "<?",
  },
};
